// extracted by mini-css-extract-plugin
module.exports = {"filter":"HTacv","left":"HTf3","right":"HTfz","linksWrapper":"HTacx","link":"HTch","active":"HTs3","spb":"HTuf","yearSelect":"HTacz","rubricSelect":"HTac1"};